export default __webpack_public_path__ + "static/media/curtis.c47ee6c4.png";